export default __webpack_public_path__ + "images/BW.1a6e9d4.png";